import { render, staticRenderFns } from "./ByDocumentsNonHistoricalComponent.vue?vue&type=template&id=c085566c"
import script from "./ByDocumentsNonHistoricalComponent.vue?vue&type=script&lang=ts"
export * from "./ByDocumentsNonHistoricalComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports